// Copyright © 2021 Move Closer
import Vue from 'vue';
import clamp from './clamp';
import closable from './closable';
import focus from './focus';
export { default as clamp } from './clamp';
export { default as closable } from './closable';
export { default as focus } from './focus';
export const directives = { clamp, closable, focus };
/**
 * Registers all custom Vue directives.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const registerDirectives = () => {
    for (const [name, handler] of Object.entries(directives)) {
        Vue.directive(name, handler);
    }
};
